<nav class="mobile-top-bar sticky-top d-md-none">
  <div class="top-bar-container">
    <button *ngIf="showBurger" type="button" class="burger-btn" (click)="openNav()" (touchend)="openNavTouch($event)" aria-label="Open navigation">
      <i class="bi bi-list"></i>
    </button>

    <div class="title-area">
      <div class="brand-row">
        <img src="assets/AivorLogo.png" alt="Aivor" class="mobile-logo" />
        <span class="mobile-page-title">{{ pageTitle }}</span>
      </div>
    </div>

    <span class="mobile-user-name" *ngIf="showLogout && userName">{{ userName }}</span>
    <button *ngIf="showLogout" class="mobile-logout-btn" (click)="authService.logOut()" aria-label="Logout">
      <i class="bi bi-box-arrow-right"></i>
    </button>
  </div>

  <div class="view-tabs" *ngIf="tabs.length > 0">
    <button
      type="button"
      *ngFor="let tab of tabs"
      class="view-tab"
      [class.active]="activeTabKey === tab.key"
      [attr.data-tour]="tab.tour ?? null"
      (click)="selectTabClick(tab)"
      (touchend)="selectTabTouch(tab, $event)"
    >
      {{ tab.label }}
    </button>
  </div>
</nav>
